import { Component, input } from '@angular/core';
import { IconComponent } from '@nagel-assests';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconSize } from '@nagel-types';

@Component({
    selector: 'lib-locked-indicator',
    imports: [
        IconComponent,
        MatTooltipModule
    ],
    templateUrl: './locked-indicator.component.html',
    styleUrl: './locked-indicator.component.scss',
})
export class LockedIndicatorComponent {
    size = input<string>('30');
    tooltipMessage = input<string>('');
    constructor() { }

    getLockedTooltipMessage = (): string => {
        return this.tooltipMessage();
    };

    getIconSize = (): IconSize => {
        return `${this.size()}x${this.size()}` as IconSize;
    };
}
